export default __webpack_public_path__ + "static/media/delete-color.76965a9b.svg";